<template>
  <div class="mb-1">
    <span class="question"> {{ question }}</span>
    <div class="form-buttons">
      <button-app
        type="button"
        class="form-button"
        color-scheme="gray"
        @clicked="$emit('no')"
      >
          {{ $t('CP.no') }}
      </button-app>
      <button-app
        type="button"
        class="form-button"
        color-scheme="blue"
        @clicked="$emit('yes')"
      >
          {{ $t('CP.yes') }}
      </button-app>
    </div>
  </div>
</template>
<script>
import ButtonApp from '../../components/Button/ButtonApp';

export default {
  name: 'YesNoQuestion',
  components: {
    ButtonApp,
  },
  props: {
    question: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.question {
  color: var(--text-main-color);
  font-size: 16px;
  font-weight: normal;
}
.form-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.form-button {
    font-size: 13px;
    width: 48%;
    font-weight: bold;
    height: 38px;
}
</style>
